module.exports = __webpack_public_path__ + "img/6.47925610.png";